import { faCalendars } from '@fortawesome/pro-solid-svg-icons';

import { NavRoute } from '../../shared/navigation/nav.route.interface';

export const getMainNavAllAppointments: () => NavRoute = () => ({
	name: "All Appointments"
    , security: sec => sec.adminFeatures
    , href: 'all-apts/list'
    , icon: faCalendars
    , area: 'all-apts'
    , expanded: globalThis.location.href.includes("/all-apts/")
    , children: getAreas()
});

function getAreas(): NavRoute[] {
    let id: string = "";
    let url = globalThis.location.href;

    if (url.includes('all-apts/view/')) { id = url.substring(url.lastIndexOf('/') + 1); }

    if (id === "") {
        return [
            {
                name: 'List'
                , exact: true
                , path: `all-apts/list`
                , activeNavLink: 'all-apts'
                , secondaryNav: [ 'All Appointments', 'List' ]
            }
        ];
    }

	return [
		{
			name: 'Back'
			, exact: true
			, path: `all-apts/list`
		}
        , {
			name: 'Details'
			, exact: true
			, path: `all-apts/view/${id}`
            , activeNavLink: 'all-apts'
            , secondaryNav: [ 'All Appointments', 'Details' ]
		}
	]
}
